import { Pipe, PipeTransform } from '@angular/core';
import { AssetsService } from '@shared-services/assets.service';

@Pipe({
  name: 'directus',
  pure: false
})
export class DirectusPipe implements PipeTransform
{
  constructor(private assetsService: AssetsService) { }

  public transform(value: string, type: string): string
  {
    let res = "";

    if (value)
    {
      res = this.assetsService.getAssetFromDirectus(value);

      if (type == 'style')
      {
        res = 'url(' + res + ')';
      }
    }

    return res;
  }
}
